// extracted by mini-css-extract-plugin
export default {"description":"Description_description__I8ajw","description__wrapper":"Description_description__wrapper__M4Iev"};